import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import Presentaciones415Table from "./Presentaciones415Table";
import { getPresentaciones415, getMuestraVigente, postPresentacion415, postFinalizarPresentacion415 } from "../../../redux/actions/resolucion";
import { Paper, Box, Button } from "@mui/material";
import TitleWithFetchData from "../../commons/table/utilsTable/TitleWithFetchData";
import DialogIniciarPresentacion from "./dialogs/DialogIniciarPresentacion";
import ConfirmDialog from "../../commons/dialog/ConfirmDialog";
import { toast } from "react-toastify";
import { Add } from "@mui/icons-material";

const PresentacionesRes81Container = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [isDialogOpen, setIsDialogOpen] = useState(false);
  const [isConfirmOpen, setIsConfirmOpen] = useState(false);
  const [selectedPresentacion, setSelectedPresentacion] = useState(null);

  const presentaciones415 = useSelector((state) => state.resolucion.presentaciones415);
  const muestraVigente = useSelector((state) => state.resolucion.muestraVigente);

  const loading = presentaciones415?.loading || false;
  const data = Array.isArray(presentaciones415?.data)
    ? presentaciones415.data
    : presentaciones415?.data?.data || [];

  useEffect(() => {
    dispatch(getPresentaciones415());
  }, [dispatch]);

  const handleVer = (row) => {
    navigate(`/prevencion/resolucion-81/detalle/${row.idPresentacion415}`, {
      state: row
    });
  };

  const handleFinalizarClick = (row) => {
    setSelectedPresentacion(row);
    setIsConfirmOpen(true);
  };

  const [isFinalizando, setIsFinalizando] = useState(false);

  const handleFinalizarConfirm = () => {
    const id = selectedPresentacion?.idPresentacion415
    if (id) {
      setIsFinalizando(true);
      dispatch(postFinalizarPresentacion415(id))
        .then(() => {
          toast.success("Presentación finalizada correctamente");
          dispatch(getPresentaciones415());
          setIsConfirmOpen(false);
          setSelectedPresentacion(null);
        })
        .finally(() => {
          setIsFinalizando(false);
        });
    }
  };

  const handleIniciarPresentacionClick = () => {
    const hasIniciada = data.some(p => p.estado === "Iniciada" || p.estado === "Pendiente de Revisión");

    if (hasIniciada) {
      toast.error("No es posible iniciar la presentacion con una muestra sin finalizar.");
      return;
    }

    dispatch(getMuestraVigente("RES81"))
      .then(() => {
        setIsDialogOpen(true);
      })
      .catch(error => {
        return;
      });
  };

  const handleSavePresentacion = (tipoPresentacion) => {
    const body = {
      tipoPresentacion: tipoPresentacion,
      idProgramaMuestra: muestraVigente?.data?.numeroMuestra,
      codigoPresentacionSRT: muestraVigente?.data?.codigoPresentacionSRT
    };

    dispatch(postPresentacion415(body))
      .then(() => {
        setIsDialogOpen(false);
        dispatch(getPresentaciones415());
        toast.success("Presentación iniciada correctamente");
      })
  };

  return (
    <>
      <Paper elevation={0} sx={{ p: 2 }}>
        <Box sx={{ display: 'flex', justifyContent: 'flex-end', mb: 2 }}>
          <Button
            variant="contained"
            startIcon={<Add />}
            onClick={handleIniciarPresentacionClick}
            sx={{
              backgroundColor: '#007A5E',
              '&:hover': {
                backgroundColor: '#005e48'
              },
              textTransform: 'none'
            }}
          >
            Iniciar Presentación
          </Button>
        </Box>
        <TitleWithFetchData
          title="Presentaciones Res. 81"
          fetchData={() => dispatch(getPresentaciones415())}
          noRefresh={false}
        />
        <Presentaciones415Table data={data} loading={loading} handleVer={handleVer} handleFinalizar={handleFinalizarClick} />
      </Paper>
      <DialogIniciarPresentacion
        open={isDialogOpen}
        onClose={() => setIsDialogOpen(false)}
        onSave={handleSavePresentacion}
        muestraVigente={muestraVigente}
      />
      <ConfirmDialog
        open={isConfirmOpen}
        handleClose={() => setIsConfirmOpen(false)}
        title="Finalizar Presentación"
        text="¿Está seguro de finalizar la presentación?"
        handleConfirm={handleFinalizarConfirm}
        loading={isFinalizando}
      />
    </>
  );
};

export default PresentacionesRes81Container;
